var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.8037 5.35478C52.2791 5.83014 52.4401 6.5358 52.218 7.17033L36.7013 51.5037C36.4643 52.1809 35.8379 52.6448 35.1209 52.6741C34.404 52.7033 33.7418 52.292 33.4504 51.6363L24.8571 32.3014L5.52218 23.708C4.86649 23.4166 4.45512 22.7545 4.48437 22.0375C4.51362 21.3206 4.97756 20.6942 5.65481 20.4571L49.9881 4.94046C50.6227 4.71838 51.3283 4.87941 51.8037 5.35478ZM10.9773 22.3024L26.8937 29.3764C27.2896 29.5523 27.6061 29.8689 27.7821 30.2648L34.856 46.1812L47.7138 9.44466L10.9773 22.3024Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8037 5.35478C52.4871 6.03819 52.4872 7.14623 51.8038 7.82965L27.4205 32.213C26.7371 32.8964 25.629 32.8964 24.9456 32.213C24.2622 31.5296 24.2622 30.4215 24.9456 29.7381L49.3289 5.35478C50.0123 4.67136 51.1203 4.67136 51.8037 5.35478Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.c2882004.svg";
export { ForwardRef as ReactComponent };